<script>
    import { createEventDispatcher } from 'svelte';
    import Button from './Button.svelte';

    const dispatch = createEventDispatcher();

    let navData = [
        {
            "id": "tldr",
            "label": "TL;DR",
            "active": true
        },
        {
            "id": "longStory",
            "label": "Long Story",
            "active": false
        },
        {
            "id": "notWorking",
            "label": "When Not Working",
            "active": false
        },
        {
            "id": "findMe",
            "label": "Find Me Here",
            "active": false
        }
    ]

    function handleClick(id) {
        dispatch('sectionChange', {
            sectionId: id
        });
        navData.forEach(item => item.active = false);
        navData[navData.findIndex(item => item.id === id)].active = true;
    }
</script>

<nav>
    {#each navData as btn}
        <div class="button-wrapper">
            <Button id={btn.id} onClick={handleClick} status={ btn.active ? "active" : "inactive"} type="primary" text={btn.label} />
        </div>
    {/each}
</nav>

<style>
    nav {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 auto;
    }

    nav .button-wrapper {
        margin: .5em;
    }
</style>